import { useTheme } from 'styled-components';

export const useIsTouchDevice = (): boolean => useTheme().mqMatch('md');
